import {
  ActiveLogLevel,
  ILogger,
  LogLevel,
  LoggerType,
  logLevelValues,
} from './logger.types';

export abstract class AbstractLogger implements ILogger {
  protected abstract readonly type: LoggerType;

  constructor(
    public readonly name: string,
    protected readonly level: LogLevel = LogLevel.None
  ) {}

  public abstract createNamedLogger(name: string): ILogger;
  public abstract setProjectContext(project?: {
    id: string;
    name: string;
    location: string;
  }): void;

  public debug(message: string, context?: object, error?: Error): void {
    this.log(LogLevel.Debug, message, context, error);
  }

  public info(message: string, context?: object, error?: Error): void {
    this.log(LogLevel.Info, message, context, error);
  }

  public warn(message: string, context?: object, error?: Error): void {
    this.log(LogLevel.Warn, message, context, error);
  }

  public error(message: string, context?: object, error?: Error): void {
    this.log(LogLevel.Error, message, context, error);
  }

  protected abstract log(
    level: LogLevel,
    message: string,
    context?: object,
    error?: Error
  ): void;

  /**
   * Returns true if this level should be logged, narrowing the type to ActiveLogLevel.
   */
  protected shouldLog(level: LogLevel): level is ActiveLogLevel {
    if (this.level === LogLevel.None || level === LogLevel.None) return false;

    const thisLevel = logLevelValues[this.level];
    const callLevel = logLevelValues[level];

    return callLevel >= thisLevel;
  }
}
